import type { ConversionEvent, ReportConversionFunction } from '../types';

// Conversion events for Zac 3
const EventIDs: { [key in ConversionEvent]: number } = {
  onboarded: 39,
};

/**
 * Fires conversion pixel for Zac 3 referrals.
 */
export const reportZac3Conversion: ReportConversionFunction = (event, partnerData, sessionID) => {
  // Make sure we have the session ID
  if (!sessionID) {
    return;
  }

  // Get request ID passed in by Zac3 in the referral URL
  const { data } = partnerData || {};
  if (!data.rid) {
    return;
  }

  const eID = EventIDs[event];

  const ifrm = window.document.createElement('iframe');
  ifrm.setAttribute('src', `https://ova-ad-serv.com/p.ashx?o=116&e=${eID}&t=${sessionID}&r=${data.rid}`);
  ifrm.style.width = '1';
  ifrm.style.height = '1';
  ifrm.frameBorder = '0';
  window.document.body.appendChild(ifrm);
};
